import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@jsverse/transloco';
import { SafePipe } from '@shared/pipes/safeUrl.pipe';

@Component({
  selector: 'app-user-docs',
  templateUrl: './documentation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  styleUrl: './documentation.component.scss',
  imports: [MatCardModule, TranslocoModule, MatIconModule, SafePipe],
})
export class UserDocsComponent {
  doc = input.required<string>();
  path = computed(() => `${window.location.origin}/assets/pdf/${this.doc()}.pdf`);
}
